<div class="search-result-pager-content-list">
  <a
    class="page-item"
    [ngClass]="{'disabled': searchContainer.displayAll || searchContainer.searchPage === 1}"
    (click)="prevPage()"
  >
    <span class="text-link">
      {{ 'TRANS__SEARCH_RESULT_PAGER__PREVIOUS' | translate }}
    </span>
  </a>

  @if (searchContainer.searchPage > 5) {
    <a
      class="page-item"
      (click)="setPage(1)"
    >
      <span class="text-link">
        1
      </span>

      <span class="page-item-first-page">
        &hellip;
      </span>
    </a>
  }

  @for (page of pages; track $index) {
    <a
      class="page-item"
      [ngClass]="{'disabled': searchContainer.displayAll || searchContainer.searchPage === page}"
      (click)="setPage(page)"
    >
      <span [ngClass]="{'current-page': page === searchPage}">
        {{page}}
      </span>
    </a>
  }

  @if (searchContainer.maxPage > endPage) {
    <a
      class="page-item page-item-last-page"
      [ngClass]="{'disabled': searchContainer.displayAll || searchContainer.searchPage === searchContainer.maxPage}"
      (click)="setLastPage()"
    >
      <span class="last-page-ellipsis">
        &hellip;
      </span>

      <span class="text-link">
        {{searchContainer.maxPage}}
      </span>
    </a>
  }


  <a
    class="page-item"
    [ngClass]="{'disabled': searchContainer.displayAll || searchContainer.searchPage === searchContainer.maxPage}"
    (click)="nextPage()"
  >
    <span class="text-link">
      {{ 'TRANS__SEARCH_RESULT_PAGER__NEXT' | translate }}
    </span>
  </a>

  @if (searchContainer.searchResultViewName !== SearchResultViewNames.SELECTOR) {
    <div
      class="page-item"
      [ngClass]="{'disabled': searchContainer.displayAll || searchContainer.maxPage < 2}"
    >
      <span>
        |
      </span>
    </div>

    <a
      class="page-item"
      (click)="toggleDisplayAll()"
      [ngClass]="{'disabled': searchContainer.maxPage < 2 && !searchContainer.displayAll}"
    >
      @if (!searchContainer.displayAll) {
        <span class="text-link">
          {{ 'TRANS__SEARCH_RESULT_PAGER__DISPLAY_ALL' | translate }}
        </span>
      }
      @else {
        <span class="text-link">
          {{ 'TRANS__SEARCH_RESULT_PAGER__DO_NOT_DISPLAY_ALL' | translate }}
        </span>
      }
    </a>
  }
</div>
